import { useEffect } from 'react';

import { useDispatch, useSelector } from 'react-redux';

import { getCmsContent as fetchCmsContent } from '@@/store/actions';
import { getCmsContent } from '@@/store/selectors';

export function useCmsContent(slug: string, fetchContent = fetchCmsContent) {
  const dispatch = useDispatch();
  const content = useSelector(getCmsContent(slug));

  useEffect(
    function fetchCmsContentIfMissing() {
      if (!content) {
        fetchContent([slug])(dispatch);
      }
    },
    [content, dispatch, slug, fetchContent]
  );

  return content;
}
